import { render } from "./PlanActivitiesView.vue?vue&type=template&id=49e6b84b"
import script from "./PlanActivitiesView.vue?vue&type=script&lang=js"
export * from "./PlanActivitiesView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__